import { useEffect, useState } from "react";
import { Badge, Button, Card, CardBody, Spinner } from "reactstrap";
import { GroupJoinRequestDto, MyGroupStatusDto } from "../types/MyGroupStatus";
import { getMyGroupStatus, joinGroup, leaveGroup } from "../Services/GroupMemberService";
// import { cancelJoinRequest, createJoinRequest, getMyJoinRequestStatus } from "../Services/GroupJoinRequestService";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import "./GroupJoinStatus.css";
import JoinCard from "./New_Components_for_Details/JoinCard";
import AuthModal from "./New_Components_for_Details/AuthModal";
import { FaCheckCircle, FaComments, FaHandshake, FaUsers } from "react-icons/fa";
import { GroupDto } from "../types/Group";
import GroupService from "../Services/GroupService";

interface Props {
  groupId: string;
  onStatusChanged?: (isMember: boolean) => void;
}

const GroupJoinStatus = ({ groupId, onStatusChanged }: Props) => {

  const { isAuthenticated } = useAuth();
   const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [group, setGroup] = useState<GroupDto | null>(null);
  // eslint-disable-next-line
  const navigate = useNavigate();
  const [member, setMember] = useState<MyGroupStatusDto | null>(null);
  // eslint-disable-next-line
  const [request, setRequest] = useState<GroupJoinRequestDto | null>(null);

  const [showAuth, setShowAuth] = useState(false);

  const [defaultTab, setDefaultTab] =
    useState<"login" | "register">("login");
  const openLogin = () => {

    setDefaultTab("login");

    setShowAuth(true);

  };
  const openRegister = () => {

    setDefaultTab("register");

    setShowAuth(true);

  };
  useEffect(() => {

    loadStatus();
    // eslint-disable-next-line
  }, [groupId]);

  // const loadStatus = async () => {

  //     setLoading(true);

  //     try {

  //         const memberResponse =
  //             await getMyGroupStatus(groupId);

  //         setMember(memberResponse);

  //         onStatusChanged?.(memberResponse.isMember);

  //         if (!memberResponse.isMember) {

  //             const requestResponse =
  //                 await getMyJoinRequestStatus(groupId);

  //             setRequest(requestResponse);

  //         }
  //         else {

  //             setRequest(null);

  //         }

  //     }
  //     catch (error) {

  //         console.error(error);

  //     }
  //     finally {

  //         setLoading(false);

  //     }

  // };



  const loadStatus = async () => {

    setLoading(true);

    try {

      const memberResponse =
        await getMyGroupStatus(groupId);

      setMember(memberResponse);

      onStatusChanged?.(memberResponse.isMember);

    }
    catch (error) {

      console.error(error);

    }
    finally {

      setLoading(false);

    }

  };

  // const handleJoin = async () => {

  //     await createJoinRequest(groupId);

  //     await loadStatus();

  // };

  const handleJoin = async () => {

    try {

      await joinGroup(groupId);

      await loadStatus();



    }
    catch (error: any) {

      const message =
        error.response?.data?.message ||
        error.response?.data ||
        "Something went wrong.";

      toast.error(message);

    }

  };

  const handleRegisterSuccess = () => {

    toast.success(
      "Registration successful. Please login to continue."
    );

  };


  // const handleCancel = async () => {

  //     await cancelJoinRequest(groupId);

  //     await loadStatus();

  // };
// eslint-disable-next-line
      const loadGroup = async () => {

        if (!slug)
            return;

        setLoading(true);

        try {

            const response =
                await GroupService.getBySlug(slug);

            setGroup(response);

        }
        catch (error) {

            console.error(error);

        }
        finally {

            setLoading(false);

        }

    };

  const handleLeave = async () => {

    if (!window.confirm("Leave this community?"))
      return;

    await leaveGroup(groupId);

    await loadStatus();

  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner />
      </div>
    );
  }

  if (member?.isMember) {
    return (
      <Card className="border-0 shadow-sm rounded-4">
        <CardBody className="p-4">

          <div className="d-flex align-items-center mb-4">

            <div
              className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center me-3"
              style={{
                width: "60px",
                height: "60px"
              }}
            >
              <FaCheckCircle
                size={28}
                className="text-success"
              />
            </div>

            <div>
              <Badge color="success" pill className="mb-2">
                Active Member
              </Badge>

              <h4 className="fw-bold mb-1">
                You're part of this buying group
              </h4>

              <p className="text-muted mb-0">
                Stay engaged to receive better offers and negotiation updates.
              </p>
            </div>

          </div>

          <div className="border rounded-3 p-3 bg-light mb-4">

            <div className="d-flex align-items-center mb-3">
              <FaHandshake className="text-primary me-3" />
              <span>Receive institute quotations and negotiated discounts.</span>
            </div>

            <div className="d-flex align-items-center mb-3">
              <FaUsers className="text-primary me-3" />
              <span>Connect with students preparing for the same course.</span>
            </div>

            <div className="d-flex align-items-center">
              <FaComments className="text-primary me-3" />
              <span>Chat with the coordinator and participate in discussions.</span>
            </div>

          </div>

          <div className="d-grid">
            <Button
              color="outline-danger"
              onClick={handleLeave}
            >
              Leave Group
            </Button>
          </div>

        </CardBody>
      </Card>
    );
  }

  return (
    <>

 <JoinCard 
  count={group?.totalMembers ?? 0}
  isAuthenticated={isAuthenticated}
  onJoin={handleJoin}
  onLogin={openLogin}
  onRegister={openRegister}
/>

      <AuthModal
        isOpen={showAuth}
        toggle={() => setShowAuth(false)}
        defaultTab={defaultTab}
        onLoginSuccess={loadStatus}
        onRegisterSuccess={handleRegisterSuccess}
      />

    </>
  );

};

export default GroupJoinStatus;